import { Table, message, Modal } from 'antd';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import './index.scss';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import {
  OrderDeliveryState,
  OrderType,
  Stop,
  StopTravelStatus,
  VehicleScheduleState,
} from '../../redux/type';
import { formatOrderList } from './formatOrderList';
import { RootState } from '../../redux/store';
import { WaterMark } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { HttpStatusCode } from '../../fetch/core/constant';
import { request } from '../../fetch/core';
import { api } from '../../fetch/bussiness/api';
import { CLSTAG } from '../../utils/constant';
import { clstagStr } from '../../utils/util';
import { getPermissionById } from '../../utils';
import { PermissionButton } from '../../utils/constant';
interface Props {
  vehicleName: string;
  visible: boolean;
  scheduleState?: any; // 调度状态
  stopList: any[]; // 调度的停靠点列表
  goalId?: number; // 本次调度规划停靠点Id
  stopAction?: string; // 停靠点动态类型
  updateModalTitle?: AnyFunc;
}

const btnTextArr = ['催取', '催装', '催卸', '催寄'];
// 埋点使用
const clstagMap = new Map([
  ['催取', CLSTAG.OrderListHastenPickUp],
  ['催装', CLSTAG.OrderListHastenLoad],
  ['催卸', CLSTAG.OrderListHastenUnload],
  ['催寄', CLSTAG.OrderListHastenSend],
]);
let timer: any;
let tagResendCode = '';
const OrderList = (props: Props) => {
  const login = useSelector((state: RootState) => state.login);
  const [orderListData, setOrderListData] = useState<any>({});
  const { taskType, scheduleStartTime } = orderListData;
  const [tableData, setTableData] = useState<OrderType[]>([]);
  const { visible, scheduleState, stopList, vehicleName, goalId, stopAction } =
    props;
  const [selectTelId, setSelectTelId] = useState(0);
  const [loading, setLoading] = useState<boolean>(true);
  useEffect(() => {
    if (visible) {
      getOrderListNew().then((res) => {
        props.updateModalTitle && props.updateModalTitle(res);
      });
      timer = setInterval(() => {
        getOrderListNew();
      }, 10000);
    } else {
      clearInterval(timer);
    }
    return () => {
      clearInterval(timer);
    };
  }, [visible]);

  const recordOperationLog = async (vehicleName: string, rowData: any) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/monitor/web/order/detail',
      body: {
        vehicleName,
        phone: rowData.contact,
        orderNo: rowData.orderId,
        user: rowData.name,
        stopName: rowData.stopName,
      },
    };
    request(requestParam);
  };

  const formatOperationLogStr = (rowData: any) => {
    return `订单信息：订单编号${rowData.orderId} 收件人${rowData.name} 手机号${rowData.contact}`;
  };
  const toggleShowOrHide = (selectedOrderId: any, rowData: any) => {
    setSelectTelId(selectedOrderId);
    if (selectedOrderId != 0) {
      recordOperationLog(vehicleName, rowData);
    }
  };
  /**
   * 获取订单列表
   */
  const getOrderListNew = async () => {
    const param = Object.assign({});
    param.vehicleName = vehicleName;
    param.stopAction = stopAction;
    if (stopAction !== 'HOME' && stopAction !== 'START') {
      if (goalId) {
        param.goalId = goalId;
      }
    }

    const requestParam: RequestOptions = {
      method: 'POST',
      path: api.getOrderList,
      body: param,
    };
    const res: any = await request(requestParam);
    setLoading(false);
    if (res.code === HttpStatusCode.Success) {
      if (res.data) {
        setOrderListData(res.data);
        const order = formatOrderList(stopList, res.data.order);
        const stopSort = order.sort((a: any, b: any) => {
          return a.sortIndexByStopId - b.sortIndexByStopId;
        });
        const stateSort =
          stopSort &&
          stopSort.sort((a: any, b: any) => {
            if (a.sortIndexByStopId === b.sortIndexByStopId) {
              return (
                a.sortIndexByDeliveryStateId - b.sortIndexByDeliveryStateId
              );
            }
          });
        const nameSort =
          stateSort &&
          stateSort.sort((a: any, b: any) => {
            if (
              a.sortIndexByDeliveryStateId === b.sortIndexByDeliveryStateId &&
              a.sortIndexByStopId === b.sortIndexByStopId
            ) {
              return a.name.charCodeAt(0) - b.name.charCodeAt(0);
            }
          });
        setTableData(nameSort);
      }
    } else {
      clearInterval(timer);
      message.error(res.message || '接口请求报错');
    }

    return res;
  };
  const resendCodeClick = async (item: any) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: api.getOrderVerifyCode,
      body: {
        vehicleName: vehicleName,
        orderId: item.id,
      },
    };
    const res: any = await request(requestParam);
    if (res.code == 0) {
      resendCodeInfo(res);
    } else {
      message.error(res.message || '接口请求报错');
    }
  };

  const resendCodeInfo = (res: any) => {
    const index = btnTextArr.indexOf(tagResendCode);
    if (res.code == HttpStatusCode.Success) {
      const messageArr = [
        '重发验证码成功！',
        '催单成功！',
        '催卸成功',
        '重发验证码成功！',
      ];
      message.success(messageArr[index]);
      tagResendCode = '';
    } else {
      const errorMesArr = [
        '重发验证码失败',
        '催单失败',
        '催卸失败',
        '重发验证码失败',
      ];
      Modal.error({
        title: errorMesArr[index],
        content: res.message,
      });
      tagResendCode = '';
    }
  };

  const orderTitle = () => {
    if (tableData.length <= 0) {
      return null;
    }
    const deliveryResultMap: any = new Map([
      ['DELIVERY', []],
      ['COMPLETED', []],
      ['OVERDUE', []],
      ['SETOUT', []],
      ['WAITING', []],
      ['ALREADY', []],
      ['UNLOAD', []],
      ['TODROPOFF', []],
      ['USERDROPPEDOFF', []],
      ['COURIERFETCHED', []],
      ['MISSDROPOFF', []],
    ]);
    tableData.forEach((item: OrderType) => {
      if (deliveryResultMap.has(item.originDeliveryState)) {
        const reuslt = deliveryResultMap.get(item.originDeliveryState);
        reuslt && reuslt.push(item);
      }
    });
    const titleInfoMap = new Map([
      [
        'LOADTASK',
        {
          [OrderDeliveryState.WAITING]: deliveryResultMap.get('WAITING').length,
          [OrderDeliveryState.ALREADY]: deliveryResultMap.get('ALREADY').length,
        },
      ],
      [
        'DELIVERY',
        {
          ['进行中']:
            deliveryResultMap.get('DELIVERY').length +
            deliveryResultMap.get('TODROPOFF').length,
          ['已完成']:
            deliveryResultMap.get('COMPLETED').length +
            deliveryResultMap.get('USERDROPPEDOFF').length +
            deliveryResultMap.get('COURIERFETCHED').length,
          ['未完成']:
            deliveryResultMap.get('OVERDUE').length +
            deliveryResultMap.get('MISSDROPOFF').length,
          [OrderDeliveryState.SETOUT]: deliveryResultMap.get('SETOUT').length,
        },
      ],
      [
        'UNLOADTASK',
        {
          [OrderDeliveryState.COMPLETED]:
            deliveryResultMap.get('COMPLETED').length,
          [OrderDeliveryState.OVERDUE]: deliveryResultMap.get('OVERDUE').length,
          [OrderDeliveryState.UNLOAD]: deliveryResultMap.get('UNLOAD').length,
        },
      ],
      [
        'DROPOFF',
        {
          [OrderDeliveryState.TODROPOFF]:
            deliveryResultMap.get('TODROPOFF').length,
          [OrderDeliveryState.USERDROPPEDOFF]:
            deliveryResultMap.get('USERDROPPEDOFF').length,
          [OrderDeliveryState.MISSDROPOFF]:
            deliveryResultMap.get('MISSDROPOFF').length,
          [OrderDeliveryState.SETOUT]: deliveryResultMap.get('SETOUT').length,
        },
      ],
    ]);

    const titleField: any = ['DELIVERY', 'DROPOFF'].includes(taskType)
      ? titleInfoMap.get('DELIVERY')
      : titleInfoMap.get(taskType);
    const liNodes: any = [];
    // eslint-disable-next-line guard-for-in
    for (const key in titleField) {
      const li = (
        <li key={key}>
          <span className='label'>{key}</span>
          <span className='value font-JDZhengHT'>{titleField[key]}</span>
        </li>
      );
      liNodes.push(li);
    }
    return (
      <ul className='my-car-info'>
        <li>
          <span className='label'>全部订单</span>{' '}
          <span className='value font-JDZhengHT'>{tableData.length}</span>
        </li>
        {liNodes}
        <li>
          {scheduleStartTime && (
            <>
              <span className='label'>调度起始 </span>{' '}
              <span className='schedule-time'>
                {dayjs(scheduleStartTime).format('YYYY-MM-DD HH:mm:ss')}
              </span>
            </>
          )}
        </li>
      </ul>
    );
  };
  const columns: any[] = [
    {
      title: taskType == 'DROPOFF' ? '寄件人' : '收件人',
      dataIndex: 'name',
      width: 90,
      key: 'name',
      ellipsis: true,
      align: 'left',
      sorter: (a: any, b: any) => {
        return a.name.localeCompare(b.name);
      },
      // eslint-disable-next-line react/display-name
      render: (text: string, record: any) => {
        const fullName = String(text);
        const encryptionName = fullName.replace(
          fullName.substring(1, fullName.length),
          '****',
        );
        return (
          <>
            {selectTelId === record.orderId ? (
              <div
                className='encryption'
                onClick={toggleShowOrHide.bind(null, 0, record)}
              >
                {fullName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeOutlined />
                </span>
              </div>
            ) : (
              <div
                className='encryption'
                onClick={toggleShowOrHide.bind(null, record.orderId, record)}
              >
                {encryptionName}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeInvisibleOutlined />
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: '手机号',
      dataIndex: 'contact',
      key: 'contact',
      align: 'left',
      width: 120,
      // eslint-disable-next-line react/display-name
      render: (text: number, record: any, index: number) => {
        const tel = String(text);
        const tel1 = tel.replace(tel.substring(3, 7), '****');
        const nextPhone = (e: any) => {
          setSelectTelId(record.orderId);
          recordOperationLog(vehicleName, record);
        };
        const prePhone = (e: any) => {
          setSelectTelId(0);
        };
        return (
          <>
            {selectTelId === record.orderId ? (
              <div className='encryption' onClick={(e) => prePhone(e)}>
                {tel}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeOutlined />
                </span>
              </div>
            ) : (
              <div className='encryption' onClick={(e) => nextPhone(e)}>
                {tel1}
                <span style={{ paddingLeft: '5px' }}>
                  <EyeInvisibleOutlined />
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: '配送方式',
      dataIndex: 'deliveryModel',
      key: 'deliveryModel',
      align: 'left',
      width: 100,
      sorter: (a: any, b: any) => {
        return (a.deliveryModel || '').localeCompare(b.deliveryModel || '');
      },
    },
    {
      title: '订单类型',
      dataIndex: 'orderSourceCode',
      key: 'orderSourceCode',
      align: 'left',
      width: 100,
      sorter: (a: any, b: any) => {
        return (a.orderSourceCode || '').localeCompare(b.orderSourceCode || '');
      },
    },
    {
      title: '投递方式',
      dataIndex: 'loadMethodName',
      key: 'loadMethodType',
      align: 'left',
      width: 100,
    },
    {
      title: '单号',
      dataIndex: 'orderId',
      key: 'orderId',
      align: 'left',
      width: 150,
      ellipsis: true,
    },
    {
      title: '包裹数',
      dataIndex: 'packageTotal',
      align: 'left',
      width: 60,
      key: 'packageTotal',
    },

    [
      VehicleScheduleState.WAITING,
      VehicleScheduleState.TOLOAD,
      VehicleScheduleState.LOADING,
      VehicleScheduleState.ALREADY,
    ].includes(scheduleState)
      ? {
          title: '停靠点',
          key: 'stopName',
          align: 'left',
          width: 150,
          dataIndex: 'stopName',
          ellipsis: true,
        }
      : {
          title: '停靠点',
          key: 'stopName',
          width: 150,
          dataIndex: 'stopName',
          ellipsis: true,
          sorter: (a: any, b: any) => a.sortIndexByStopId - b.sortIndexByStopId,
        },
    {
      title: '状态',
      align: 'left',
      key: 'deliveryState',
      width: 80,
      dataIndex: 'deliveryState',
      sorter: {
        compare: (a: any, b: any) =>
          a.sortIndexByDeliveryStateId - b.sortIndexByDeliveryStateId,
      },
      // sorter: true,
      render: (record: any) => {
        if (
          record === OrderDeliveryState.OVERDUE ||
          record === OrderDeliveryState.MISSLOAD ||
          record === OrderDeliveryState.MISSUNLOAD ||
          record === OrderDeliveryState.MISSDROPOFF
        ) {
          return <span className='red'>{record}</span>;
        } else if (record === OrderDeliveryState.USERCANCEL) {
          return <span className='origin'>{record}</span>;
        } else {
          return <span className='green'>{record}</span>;
        }
      },
    },
    {
      title: '格口',
      key: 'gridNoList',
      dataIndex: 'gridNoList',
      width: 50,
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: (record: any) => {
        return <div>{record.toString()}</div>;
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'left',
      width: 50,
      // eslint-disable-next-line react/display-name
      render: (_text: any, record: any) => {
        const stayingStop: any =
          stopList.find(
            (item: Stop) => item.travelStatus === StopTravelStatus.STAY,
          ) || {};
        const isDelivery = record.deliveryState === OrderDeliveryState.DELIVERY;
        const isWaiting =
          record.deliveryState == OrderDeliveryState.WAITING &&
          scheduleState === 'LOADING' &&
          record.loadStopId == stayingStop.id;
        const isUnloading =
          record.deliveryState === OrderDeliveryState.OVERDUE &&
          scheduleState === 'UNLOADING' &&
          record.loadStopId === stayingStop.id;
        const isToDropOff =
          record.deliveryState === OrderDeliveryState.TODROPOFF &&
          scheduleState === 'DELIVERY';

        if (isDelivery || isWaiting || isUnloading || isToDropOff) {
          const active = isDelivery
            ? btnTextArr[0]
            : isWaiting
              ? btnTextArr[1]
              : isUnloading
                ? btnTextArr[2]
                : isToDropOff
                  ? btnTextArr[3]
                  : btnTextArr[0];
          return getPermissionById(PermissionButton.SPV_ORDER_OPERATIONS) ? (
            <span
              className='action'
              clstag={clstagStr(clstagMap.get(active)!)}
              onClick={() => {
                tagResendCode = active;
                resendCodeClick(record);
              }}
            >
              {active}
            </span>
          ) : (
            <></>
          );
        }
        return null;
      },
    },
  ];
  const onChange = (_pagination: any, filter: any, sorter: any) => {
    const { columnKey, order } = sorter;
  };

  return (
    <WaterMark
      content={login.user && login.user.username}
      fontColor='rgba(255,255,255,.15)'
      className='jd-warter-mark'
    >
      <>
        {orderTitle()}
        <Table
          loading={loading}
          className='my-table re-table'
          size='middle'
          dataSource={tableData}
          rowKey={(record: any) => record.orderId}
          onChange={onChange}
          columns={columns}
          pagination={false}
          scroll={{ y: 500 }}
        />
      </>
    </WaterMark>
  );
};
export default React.memo(OrderList);
